import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Catalog from "@/pages/Catalog";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Portal from "@/pages/Portal";
import Home from "@/pages/site/Home";
import About from "@/pages/site/About";
import Services from "@/pages/site/Services";
import ServiceDetail from "@/pages/site/ServiceDetail";
import ServiceAreas from "@/pages/site/ServiceAreas";
import DistrictDetail from "@/pages/site/DistrictDetail";
import OurWork from "@/pages/site/OurWork";
import Industries from "@/pages/site/Industries";
import FireNOC from "@/pages/site/FireNOC";
import AMC from "@/pages/site/AMC";
import Careers from "@/pages/site/Careers";
import Contact from "@/pages/site/Contact";
import NotFound from "@/pages/site/NotFound";
import { LeadModalProvider } from "@/pages/site/shared";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <LeadModalProvider>
            <Routes>
              {/* Public marketing website */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              {/* Legacy/mistyped short slug — permanently point to the real service page.
                  True server-level 301s aren't possible for non-/api paths on this platform
                  (Kubernetes ingress routes non-/api paths straight to the static frontend,
                  so only this app's own React Router can react) — this client-side redirect
                  fires before any content paints and updates the address bar immediately,
                  which is the standard/recommended fix for this constraint on SPA sites. */}
              <Route path="/services/emergency-lighting" element={<Navigate to="/services/emergency-lighting-exit-signage" replace />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/service-areas/:slug" element={<DistrictDetail />} />
              <Route path="/our-work" element={<OurWork />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/fire-noc-support" element={<FireNOC />} />
              <Route path="/amc" element={<AMC />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />

              {/* Product catalog + auth + protected portal — unchanged */}
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/portal/*" element={<Protected><Portal /></Protected>} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </LeadModalProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
